export const FEMALE_QUESTIONS = {
    safety: {
        id: 'safety',
        number: 1,
        text: 'First, let\'s confirm, do you currently have any of the following conditions?',
        hint: 'For your health and safety, we need to know these first',
        type: 'checkbox',
        options: [
            { value: 'pregnant', label: '🤰 Pregnant' },
            { value: 'breastfeeding', label: '🤱 Breastfeeding' },
            { value: 'gynecological', label: '🩺 Have gynecological diseases (uterine fibroids, ovarian cysts, etc.)' },
            { value: 'hormone_medication', label: '💊 Taking hormonal medications' },
            { value: 'none', label: '✓ None of the above, continue', exclusive: true }
        ]
    },

    demographics: {
        id: 'demographics',
        number: 2,
        text: 'Tell us some basic information',
        type: 'multi-part',
        parts: [
            {
                id: 'age',
                label: 'Age Group',
                type: 'radio',
                options: [
                    { value: '18-25', label: '18-25 years' },
                    { value: '26-35', label: '26-35 years' },
                    { value: '36-45', label: '36-45 years' },
                    { value: '46-55', label: '46-55 years' },
                    { value: 'other', label: 'Other age group' }
                ]
            },
            {
                id: 'weight',
                label: 'Weight',
                type: 'radio',
                options: [
                    { value: '<50', label: '< 110 lbs (< 50 kg)' },
                    { value: '50-60', label: '110-132 lbs (50-60 kg)' },
                    { value: '60-70', label: '132-154 lbs (60-70 kg)' },
                    { value: '>70', label: '> 154 lbs (> 70 kg)' }
                ]
            }
        ]
    },

    mainConcern: {
        id: 'mainConcern',
        number: 3,
        text: 'What do you mainly want to regulate?',
        type: 'radio',
        options: [
            { value: 'menstrual', label: '🩸 Irregular menstruation (cycle, flow, cramps)' },
            { value: 'mood', label: '😰 Mood issues (irritability, anxiety, anger)' },
            { value: 'menopause', label: '🌡️ Menopause symptoms (hot flashes, sweating)' },
            { value: 'fertility', label: '🤰 Fertility preparation' },
            { value: 'overall', label: '🌸 Overall endocrine balance' }
        ]
    },

    // 分支A：月经不调
    menstrualIssues: {
        id: 'menstrualIssues',
        number: 4,
        text: 'What is your main menstrual issue?',
        hint: 'You can select 1-2 that bother you the most',
        type: 'checkbox',
        maxSelect: 2,
        condition: (answers) => answers.mainConcern === 'menstrual',
        options: [
            { value: 'irregular_cycle', label: 'Irregular cycle (early or late)' },
            { value: 'light_flow', label: 'Light flow' },
            { value: 'heavy_flow', label: 'Heavy flow' },
            { value: 'dysmenorrhea', label: 'Dysmenorrhea (cramps)' }
        ]
    },

    menstrualCycle: {
        id: 'menstrualCycle',
        number: 5,
        text: 'Menstrual cycle situation?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'menstrual',
        options: [
            { value: 'early', label: 'Early (less than 25 days)' },
            { value: 'late', label: 'Late (more than 35 days)' },
            { value: 'irregular', label: 'Irregular (sometimes early, sometimes late)' },
            { value: 'normal_cycle', label: 'Normal cycle but have other issues' }
        ]
    },

    dysmenorrheaSeverity: {
        id: 'dysmenorrheaSeverity',
        number: 6,
        text: 'Severity of cramps?',
        type: 'radio',
        condition: (answers) => answers.menstrualIssues?.includes('dysmenorrhea'),
        options: [
            { value: 'mild', label: 'Mild (slight pain, does not affect life)' },
            { value: 'moderate', label: 'Moderate (obvious pain, need rest)' },
            { value: 'severe', label: 'Severe (severe pain, affects work/life)' }
        ]
    },

    dysmenorrheaSymptoms: {
        id: 'dysmenorrheaSymptoms',
        number: 7,
        text: 'What else happens during cramps?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.menstrualIssues?.includes('dysmenorrhea'),
        options: [
            { value: 'blood_clots', label: 'Many blood clots' },
            { value: 'back_pain', label: 'Back pain' },
            { value: 'cold_limbs', label: 'Cold hands and feet' },
            { value: 'nausea', label: 'Nausea' }
        ]
    },

    // 分支B：情绪问题
    moodIssues: {
        id: 'moodIssues',
        number: 4,
        text: 'What are your main mood issues?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'mood',
        options: [
            { value: 'irritable', label: '😤 Easily irritable, angry' },
            { value: 'anxious', label: '😰 Anxious, nervous' },
            { value: 'depressed', label: '😔 Depressed, low mood' },
            { value: 'emotional', label: '😢 Emotional swings, easily cry' }
        ]
    },

    moodTiming: {
        id: 'moodTiming',
        number: 5,
        text: 'When are mood issues noticeable?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'mood',
        options: [
            { value: 'before_period', label: 'Worse before period' },
            { value: 'during_period', label: 'Worse during period' },
            { value: 'all_month', label: 'Throughout the month' },
            { value: 'stress', label: 'Worse when stressed' }
        ]
    },

    moodDuration: {
        id: 'moodDuration',
        number: 6,
        text: 'How long has it lasted?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'mood',
        options: [
            { value: '1-3months', label: 'Last 1-3 months' },
            { value: '3-6months', label: '3-6 months' },
            { value: '>6months', label: 'Over half a year' }
        ]
    },

    // 分支C：更年期症状
    menopauseSymptoms: {
        id: 'menopauseSymptoms',
        number: 4,
        text: 'What are your menopause symptoms?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'menopause',
        options: [
            { value: 'hot_flashes', label: '🔥 Hot flashes, sweating (paroxysmal fever)' },
            { value: 'insomnia', label: '😴 Insomnia, poor sleep quality' },
            { value: 'mood', label: '😰 Irritable mood, anxiety' },
            { value: 'palpitations', label: '💓 Palpitations, heart flutters' },
            { value: 'joint_pain', label: '🦴 Joint pain' }
        ]
    },

    menopauseMenstrual: {
        id: 'menopauseMenstrual',
        number: 5,
        text: 'Menstrual status?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'menopause',
        options: [
            { value: 'regular', label: 'Still regular, but have pre-menopause symptoms' },
            { value: 'irregular', label: 'Cycle starting to be irregular' },
            { value: 'stopped', label: 'Stopped (menopause)' }
        ]
    },

    menopauseDuration: {
        id: 'menopauseDuration',
        number: 6,
        text: 'How long have symptoms lasted?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'menopause',
        options: [
            { value: 'recent', label: 'Started within the last few months' },
            { value: '6-12months', label: '6 months to 1 year' },
            { value: '>1year', label: 'Over 1 year' }
        ]
    },

    // 分支D：备孕调理
    fertilityDuration: {
        id: 'fertilityDuration',
        number: 4,
        text: 'How long have you been trying to conceive?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'fertility',
        options: [
            { value: 'just_started', label: 'Just started preparing' },
            { value: '3-6months', label: '3-6 months' },
            { value: '6-12months', label: '6-12 months' },
            { value: '>1year', label: 'Over 1 year' }
        ]
    },

    fertilityMenstrual: {
        id: 'fertilityMenstrual',
        number: 5,
        text: 'Menstrual situation?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'fertility',
        options: [
            { value: 'regular', label: 'Regular cycle' },
            { value: 'somewhat_irregular', label: 'Somewhat irregular' },
            { value: 'very_irregular', label: 'Very irregular' }
        ]
    },

    fertilityCondition: {
        id: 'fertilityCondition',
        number: 6,
        text: 'Physical condition?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'fertility',
        options: [
            { value: 'cold_limbs', label: 'Cold hands and feet' },
            { value: 'fatigue', label: 'Easily fatigued' },
            { value: 'poor_sleep', label: 'Poor sleep' },
            { value: 'stress', label: 'High stress, anxiety' },
            { value: 'good', label: 'Condition is quite good' }
        ]
    },

    // 分支E：整体调理
    overallGoals: {
        id: 'overallGoals',
        number: 4,
        text: 'What do you mainly want to improve?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'overall',
        options: [
            { value: 'prevent_menstrual', label: 'Prevent menstrual issues' },
            { value: 'skin', label: 'Improve skin (acne, dullness)' },
            { value: 'mood', label: 'Improve mood state' },
            { value: 'energy', label: 'Boost energy' }
        ]
    },

    overallMenstrual: {
        id: 'overallMenstrual',
        number: 5,
        text: 'Current menstrual status?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'overall',
        options: [
            { value: 'very_regular', label: 'Very regular, no obvious issues' },
            { value: 'occasional', label: 'Occasional discomfort' },
            { value: 'some_issues', label: 'Some minor issues' }
        ]
    },

    // 通用问题
    constitution: {
        id: 'constitution',
        number: 7,
        text: 'Constitution characteristics?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'cold_limbs', label: '🧊 Cold hands and feet, fear of cold' },
            { value: 'heat', label: '🔥 Easily inflamed, dry mouth' },
            { value: 'sweating', label: '😓 Easily sweat' },
            { value: 'dry_mouth', label: '💧 Dry mouth, always want to drink water' },
            { value: 'none', label: 'None of the above', exclusive: true }
        ]
    },

    otherSymptoms: {
        id: 'otherSymptoms',
        number: 8,
        text: 'Do you also have these conditions?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'insomnia', label: '💤 Insomnia or poor sleep quality' },
            { value: 'appetite', label: '🍽️ Poor appetite or binge eating' },
            { value: 'fatigue', label: '😴 Easily fatigued' },
            { value: 'breast_tenderness', label: '🌸 Breast tenderness (before period)' },
            { value: 'constipation', label: '💩 Constipation' },
            { value: 'none', label: 'None of the above', exclusive: true }
        ]
    },

    stress: {
        id: 'stress',
        number: 9,
        text: 'Stress and life?',
        type: 'radio',
        options: [
            { value: 'high', label: '😫 High stress' },
            { value: 'moderate', label: '😊 Moderate stress' },
            { value: 'low', label: '😌 Relatively relaxed' }
        ]
    }
};